import { useLocation } from "react-router-dom";
// ** Icons Import
import {
  Home,
  Search,
  Package,
  Video,
  Users,
  PieChart,
  MessageSquare,
  Activity,
  Smartphone,
  Grid,
  Mail,
  Youtube,
} from "react-feather";

const Published = () => {
  const location = useLocation();
  const isPublishedRoute = location.pathname.includes("/published");

  const publishedIcon = (iconName) => (
    <img
      src={require(`@src/assets/images/vyrill/videos/${iconName}.png`).default}
      width={20}
      height={20}
      style={{ marginRight: "1.1rem" }}
    />
  );

  if (isPublishedRoute) {
    return publishedIcon("publishedActive");
  }
  return publishedIcon("publishedNonActive");
};

const VideoCarouselIcon = () => {
  const location = useLocation();
  const isCarouselRoute = location.pathname.includes("/video_carousel");

  return (
    <svg
      width="21"
      height="14"
      viewBox="0 0 21 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4375 14H6.5625C6.2144 14 5.88056 13.8525 5.63442 13.5899C5.38828 13.3274 5.25 12.9713 5.25 12.6V1.4C5.25 1.0287 5.38828 0.672601 5.63442 0.41005C5.88056 0.1475 6.2144 0 6.5625 0H14.4375C14.7856 0 15.1194 0.1475 15.3656 0.41005C15.6117 0.672601 15.75 1.0287 15.75 1.4V12.6C15.75 12.9713 15.6117 13.3274 15.3656 13.5899C15.1194 13.8525 14.7856 14 14.4375 14ZM6.5625 1.4V12.6H14.4375V1.4H6.5625ZM2.625 12.6H0V11.2H2.625V2.8H0V1.4H2.625C2.9731 1.4 3.30694 1.5475 3.55308 1.81005C3.79922 2.0726 3.9375 2.4287 3.9375 2.8V11.2C3.9375 11.5713 3.79922 11.9274 3.55308 12.1899C3.30694 12.4525 2.9731 12.6 2.625 12.6ZM21 12.6H18.375C18.0269 12.6 17.6931 12.4525 17.4469 12.1899C17.2008 11.9274 17.0625 11.5713 17.0625 11.2V2.8C17.0625 2.4287 17.2008 2.0726 17.4469 1.81005C17.6931 1.5475 18.0269 1.4 18.375 1.4H21V2.8H18.375V11.2H21V12.6Z"
        fill={isCarouselRoute ? "#e62580" : "#625f6e"}
        stroke={isCarouselRoute ? "#e62580" : "#625f6e"}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default [
  {
    id: "home",
    title: "Home",
    icon: <Home />,
    navLink: "/home",
  },
  // {
  //   id: "search",
  //   title: "Search",
  //   icon: <Search />,
  //   navLink: "/search"
  // },
  {
    id: "products",
    title: "Products",
    icon: <Package />,
    navLink: "/products",
  },
  {
    id: "videos",
    title: "Videos",
    icon: <Video />,
    navLink: "/videos",
  },
  // {
  // {  hiding creator tab
  //   id: "creators",
  //   title: "Creators",
  //   icon: <Users />,
  //   navLink: "/influencers",
  // },
  {
    id: "report",
    title: "Reports",
    icon: <PieChart />,
    navLink: "/report",
  },
  {
    id: "Video Carousel",
    title: "Video Carousel",
    icon: <VideoCarouselIcon />,
    navLink: "/video_carousel",
  },
  // {
  //   id: "Published",
  //   title: "Published",
  //   icon: <Smartphone />,
  //   navLink: "/published",
  // },
  // {
  //   id: "chat",
  //   title: "Chat",
  //   icon: <MessageSquare />,
  //   navLink: "/chat"
  // },
  // {
  //   id: "chat",
  //   title: "Messages",
  //   icon: <Mail />,
  //   navLink: "/chat",
  //   badge: "light-danger",
  //   badgeText: "1",
  // },
  // {
  //   id: "campaigns",
  //   title: "Campaigns",
  //   icon: <Activity />,
  //   navLink: "/campaigns"
  // },
  // {
  //   id: "videoApp",
  //   title: "Video App",
  //   icon: <Smartphone />,
  //   navLink: "/videoApp"
  // }
];
